import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {},
    select: {
        '&:focus': {
            borderRadius: theme.border.small.radius,
            borderWidth: theme.border.small.width,
            borderColor: theme.palette.primary.main,
            borderStyle: theme.border.small.style,
        },
    },
    outlined: {
        borderRadius: theme.border.small.radius,
        borderWidth: theme.border.small.width,
        borderColor: "#99a5bd",
        borderStyle: theme.border.small.style,
    },
    disabled: {
        backgroundColor: '#ddd',
        opacity: 0.8,
    },
}));

export default useStyles;
